import { render, staticRenderFns } from "./ruike_print_label.vue?vue&type=template&id=80964cc8&scoped=true&"
import script from "./ruike_print_label.vue?vue&type=script&lang=js&"
export * from "./ruike_print_label.vue?vue&type=script&lang=js&"
import style0 from "./ruike_print_label.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ruike_print_label.vue?vue&type=style&index=1&id=80964cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80964cc8",
  null
  
)

export default component.exports